<script>
  import { onMount } from 'svelte';
  import { getApiUrl } from '../api';
  import { authStore } from '../authStore';
  import { authFetch } from '../authService'; // <-- IMPORT THIS

  let messages = [];
  let isLoading = true;
  let error = '';
  let currentUser = null;

  // New state for image modal
  let showImageModal = false;
  let selectedImageUrl = '';

  onMount(async () => {
    const unsubscribe = authStore.subscribe(value => {
      currentUser = value.user;
    });

    if (currentUser) {
      await fetchMessages();
    }

    return unsubscribe;
  });

  async function fetchMessages() {
    isLoading = true;
    error = '';
    try {
      const userId = currentUser?.idTokenClaims?.oid;
      const response = await authFetch(getApiUrl(`/messages/inbox/${userId}`));
      if (!response.ok) throw new Error('Could not fetch inbox messages.');
      messages = await response.json();
    } catch (e) {
      error = e.message;
    } finally {
      isLoading = false;
    }
  }

  function formatDate(dateString) {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString('en-US', {
      year: 'numeric', month: 'short', day: 'numeric',
      hour: '2-digit', minute: '2-digit'
    });
  }

  function openImage(url) {
      selectedImageUrl = url;
      showImageModal = true;
  }
</script>

{#if showImageModal}
  <div class="modal-backdrop" on:click={() => showImageModal = false}>
      <div class="modal-content" on:click|stopPropagation>
          <img src={selectedImageUrl} alt="Promotion" />
          <button class="close-btn" on:click={() => showImageModal = false}>&times;</button>
      </div>
  </div>
{/if}

<div class="inbox-container">
  <h2>My Inbox</h2>
  <p>Here are the latest promotional messages for you.</p>

  {#if isLoading}
    <p>Loading messages...</p>
  {:else if error}
    <p class="error">{error}</p>
  {:else if messages.length === 0}
    <p>Your inbox is empty.</p>
  {:else}
    <div class="message-list">
      {#each messages as msg (msg._id)}
        <div class="message-card">
          <h4>{msg.subject}</h4>
          
          <!-- NEW: Image Display -->
          {#if msg.imageUrl}
             <div class="msg-image-container" on:click={() => openImage(msg.imageUrl)}>
                 <img src={msg.imageUrl} alt="Promotion" />
             </div>
          {/if}

          <p class="message-body">{msg.body}</p>
          <div class="message-footer">
            <span>Sent: {formatDate(msg.sentDate)}</span>
            <span>Expires: {formatDate(msg.expiryDate)}</span>
          </div>
        </div>
      {/each}
    </div>
  {/if}
</div>

<style>
  .inbox-container {
    max-width: 800px;
    margin: 2rem auto;
    padding: 0 1rem;
  }

  .message-list {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
  }

  .message-card {
    background: #fff;
    border: 1px solid #dee2e6;
    border-left: 5px solid #007bff;
    border-radius: 8px;
    padding: 1.5rem;
    box-shadow: 0 4px 6px rgba(0,0,0,0.05);
    text-align: left;
  }

  .message-card h4 {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1.2rem;
  }
  
  .msg-image-container {
      margin-bottom: 1rem;
      cursor: pointer;
      max-width: 100%;
      border-radius: 8px;
      overflow: hidden;
  }
  .msg-image-container img {
      max-width: 100%;
      max-height: 300px;
      object-fit: cover;
      border-radius: 4px;
      display: block;
  }
  
  .message-body {
    white-space: pre-wrap; /* Respects newlines and spaces in the message body */
    color: #333;
    line-height: 1.5;
  }

  .message-footer {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #eee;
    font-size: 0.85rem;
    color: #6c757d;
    display: flex;
    justify-content: space-between;
  }

  .error { color: red; }

  /* Modal Styles */
  .modal-backdrop { position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.8); display: flex; justify-content: center; align-items: center; z-index: 2000; }
  .modal-content { position: relative; max-width: 90%; max-height: 90%; }
  .modal-content img { max-width: 100%; max-height: 90vh; border-radius: 4px; box-shadow: 0 0 20px rgba(0,0,0,0.5); }
  .close-btn { position: absolute; top: -40px; right: 0; background: none; border: none; color: white; font-size: 2rem; cursor: pointer; }
</style>
